import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { clamp } from "./input-range-utils-fn";
/**
 * Convert a point into a percentage value
 */
export const getPercentageFromPosition = (position, clientRect) => {
  const length = clientRect.width;
  const sizePerc = position.x / length;
  return sizePerc || 0;
};

/**
 * Convert a point into a model value
 */
export const getValueFromPosition = (position, minValue, maxValue, clientRect) => {
  const sizePerc = getPercentageFromPosition(position, clientRect);
  const valueDiff = maxValue - minValue;
  return minValue + valueDiff * sizePerc;
};

/**
 * Convert props into a range value
 */
export const getValueFromProps = (props, isMultiValue) => {
  if (isMultiValue) {
    return _objectSpread({}, props.value);
  }
  return {
    min: props.minValue,
    max: props.value
  };
};

/**
 * Convert a model value into a percentage value
 */
export const getPercentageFromValue = (value, minValue, maxValue) => {
  const validValue = clamp(value, minValue, maxValue);
  const valueDiff = maxValue - minValue;
  const valuePerc = (validValue - minValue) / valueDiff;
  return valuePerc || 0;
};

/**
 * Convert model values into percentage values
 */
export const getPercentagesFromValues = (values, minValue, maxValue) => {
  return {
    min: getPercentageFromValue(values.min, minValue, maxValue),
    max: getPercentageFromValue(values.max, minValue, maxValue)
  };
};

/**
 * Convert a value into a point
 */
export const getPositionFromValue = (value, minValue, maxValue, clientRect) => {
  const length = clientRect.width;
  const valuePerc = getPercentageFromValue(value, minValue, maxValue);
  const positionValue = valuePerc * length;
  return {
    x: positionValue,
    y: 0
  };
};

/**
 * Convert a range of values into points
 */
export const getPositionsFromValues = (values, minValue, maxValue, clientRect) => {
  return {
    min: getPositionFromValue(values.min, minValue, maxValue, clientRect),
    max: getPositionFromValue(values.max, minValue, maxValue, clientRect)
  };
};

/**
 * Convert an event into a point
 */
export const getPositionFromEvent = (event, clientRect) => {
  const length = clientRect.width;
  const {
    clientX
  } = event.touches ? event.touches[0] : event;
  return {
    x: clamp(clientX - clientRect.left, 0, length),
    y: 0
  };
};

/**
 * Convert a value into a step value
 */
export const getStepValueFromValue = (value, valuePerStep) => {
  return Math.round(value / valuePerStep) * valuePerStep;
};